/**
 * Shared catalogues for in-person session create/edit forms.
 */

import { useQuery } from '@tanstack/react-query';
import { getEstablishments, getClassrooms } from '@/services/establishments.service';
import { getLevels } from '@/services/levels.service';
import { getSubjects } from '@/services/subjects.service';
import { getPrograms } from '@/services/programs.service';
import { getActivities } from '@/services/activities.service';

/** React Query loads of establishments, classrooms, levels, subjects, programs, and activities. */
export const useSessionFormData = () => {
  const establishments = useQuery({
    queryKey: ['establishments'],
    queryFn: () => getEstablishments(),
  });

  const classrooms = useQuery({
    queryKey: ['classrooms'],
    queryFn: () => getClassrooms(),
  });

  const levels = useQuery({
    queryKey: ['levels'],
    queryFn: async () => {
      const response = await getLevels();
      return response.data;
    },
  });

  const subjects = useQuery({
    queryKey: ['subjects'],
    queryFn: async () => {
      const response = await getSubjects();
      return response.data;
    },
  });

  const programs = useQuery({
    queryKey: ['programs'],
    queryFn: async () => {
      const response = await getPrograms();
      return response.data;
    },
  });

  const activities = useQuery({
    queryKey: ['activities'],
    queryFn: async () => {
      const response = await getActivities();
      return response.data;
    },
  });

  return {
    establishments: establishments.data?.data || [],
    classrooms: classrooms.data || [],
    levels: levels.data || [],
    subjects: subjects.data || [],
    programs: programs.data || [],
    activities: activities.data || [],
    isLoading:
      establishments.isLoading ||
      classrooms.isLoading ||
      levels.isLoading ||
      subjects.isLoading ||
      programs.isLoading ||
      activities.isLoading,
  };
};
